module.exports = __webpack_public_path__ + "img/extra-step-1.df2f9d82.png";